import enCommon from './en/common';
import esCommon from './es/common';
import ptCommon from './pt/common';
import enPrivacy from './en/privacy';
import esPrivacy from './es/privacy';
import ptPrivacy from './pt/privacy';
import enTerms from './en/terms';
import esTerms from './es/terms';
import ptTerms from './pt/terms';

export const resources = {
  en: {
    common: enCommon,
    privacy: enPrivacy,
    terms: enTerms,
  },
  es: {
    common: esCommon,
    privacy: esPrivacy,
    terms: esTerms,
  },
  pt: {
    common: ptCommon,
    privacy: ptPrivacy,
    terms: ptTerms,
  },
};
